import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  class: "time-out-flag"
}
const _hoisted_3 = {
  key: 1,
  class: "new-list-flag"
}
const _hoisted_4 = {
  key: 2,
  class: "black-list-flag"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 6 }

import { reactive, computed, onMounted, ref } from 'vue'
import CosMergeButton from '@/components/CosMergeButton'
import { potentialList, potentialDel, potentialDetail, potentialArchive } from '@/api/overseasSales/customerCenter'
import dataConfig from '@/views/overseasSales/commonEnum/dataConfig'
import relationCode from '../components/relationCode/index.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import addCodeModel from '@/views/overseasSales/customerCenter/accountCode/editModal.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import sendLinkModel from '../components/sendLinkModel.vue'
import transferModel from '../components/transferModel.vue'
import { useRouter, useRoute } from 'vue-router'
import { Modal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import { listByParamCodes } from '@/api/common'
import calc from '@/utils/calc'
import DCModal from '@/hooks/modalType'
import type { PotentialItem } from '@/typings/api/customerCenter'
import type { ParamCodeItem } from '@/typings/common'
import { useI18n } from 'vue-i18n'
import { cloneDeep } from 'lodash-es'
import { queryMarketActivityList } from '@/api/marketing/marketingManage'
import CosSelect from '@/components/Antd/CosSelect/index.vue'

const __default__ = { name: 'DcCosOFbuPotential' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const tableRef = ref()
const sendLinkModelRef = ref()
const addCodeModelRef = ref()
const relationCodeRef = ref()
const transferModelRef = ref()
const selectedRows = ref<PotentialItem[]>([])
const queryForm = reactive({
  dataPermissionType: undefined,
  contact: {
    type: 1
  },
  stage: 2 // 2 潜在 3签约 4成交
})
const paramCodeData = reactive<{
  [key: string]: ParamCodeItem[]
}>({
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 货物类型
  ofbu_warehouse: [], // 合作海外仓
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_service_demand: [], // 服务需求
  ofbu_demand_info: [], // 需求海外仓
  ofbu_erp_info: [], // 目前使用ERP
  ofbu_replenish_frequency: [], // 头程补货频次
  ofbu_business_type: [], // 客户业务类型
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_customer_size: [], // 客户规模
  ofbu_services_standard: [], // 服务标准
  ofbu_currency: [], // 币种
  ofbu_sales_channel: [], // 销售渠道
  ofbu_service_type: [], // 尾程服务需求
  ofbu_inbound_package_type: [], // 入库包装方式
  ofbu_sku_unit: [], // sku单位
  ofbu_client_type: [] // 客户业务类型
})
const marketOptions = ref<any[]>([])
const getMarketOption = () => {
  queryMarketActivityList({ subdomain: 'cos_ofbu' }).then((res) => {
    if (res.data && res.data.length) {
      marketOptions.value = res.data.map((item: any) => ({
        label: item.activityName,
        value: item.id
      }))
    }
  })
}
onMounted(() => {
  getByParamCodes()
  getMarketOption()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_warehouse',
      'ofbu_sale_platform',
      'ofbu_service_demand',
      'ofbu_demand_info',
      'ofbu_erp_info',
      'ofbu_replenish_frequency',
      'ofbu_business_type',
      'ofbu_marketing_activity',
      'ofbu_customer_size',
      'ofbu_services_standard',
      'ofbu_currency',
      'ofbu_sales_channel',
      'ofbu_service_type',
      'ofbu_inbound_package_type',
      'ofbu_sku_unit',
      'ofbu_client_type'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const search = () => {
  tableRef.value.search()
}
// 获取列表
const fetch = (queryForm: object, callBack: (res: any) => void) => {
  const params = cloneDeep(queryForm)
  const cosIds = params.cosId?.split(/[,，\s\n]/).filter((e: string) => e)
  const arkCodes = params.arkCode?.split(/[,，\s\n]/).filter((e: string) => e)
  if (cosIds && cosIds.length > 1) {
    params.cosIdList = cosIds
    delete params.cosId
  }
  if (arkCodes && arkCodes.length > 1) {
    params.arkCodeList = arkCodes
    delete params.arkCode
  }
  potentialList({
    ...params
  }).then((res) => {
    callBack(res)
  })
}
// 获取掩码信息
const showMask = (record: PotentialItem, callBack: (res: any) => void) => {
  potentialDetail(record.cosId).then((res) => {
    callBack(res.data.contact)
  })
}
// 算总额
const amount = (v: []) => {
  if (v && v.length) {
    const result = v.reduce((prev: number, curr: any) => calc.Add(prev, Number(curr.amount) || 0), 0)
    return result || 0
  }
  return 0
}

const onSelectChange = (selectedRowKeys: string[], rows: PotentialItem[]) => {
  selectedRows.value = rows
}
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle(selectedRows.value)
}
// 归档
const handleArchive = (row?: PotentialItem) => {
  const ids: any[] = selectedRows.value?.map((item) => item.cosId)
  if (!ids || ids.length < 1) {
    message.error(t('tips.chooseData'))
    return
  }
  DCModal.switch({
    title: t('tips.Ye9Qb3'),
    onOk() {
      potentialArchive({ cosIdList: ids }).then(() => {
        message.success(t('tips.7bMTZIE'))
        success()
      })
    }
  })
}
// 删除
const handleDelete = (row: PotentialItem) => {
  DCModal.delete({
    content: t('custom.CUn3xat3', { customerName: row.customerName }),
    onOk() {
      potentialDel({ cosIdList: [row.cosId] }).then(() => {
        message.success(t('tips.delSuccess'))
        tableRef.value.delFetch()
      })
    }
  })
}
// 关联客户代码
const handleRelationCode = (row: PotentialItem) => {
  relationCodeRef.value.toggle(row)
}
// 新增关联代码
const handleAddCode = (row: PotentialItem) => {
  addCodeModelRef.value.toggle({
    cosId: row.cosId
  })
}
// 编辑
const handleEdit = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/potential/edit',
    query: {
      cosId: row.cosId
    }
  })
}
// 完善资料
const handlePerfect = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/potential/perfect',
    query: {
      cosId: row.cosId
    }
  })
}
// 写跟进
const handleFollowUp = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: {
      followRefId: row.cosId,
      returnPath: route.fullPath
    }
  })
}
// 写商机
const handleAddBuss = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/business/add',
    query: {
      saleChanceRefId: row.cosId
    }
  })
}
// 新增访客计划
const hanleAddVisitor = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/visitorProgram/add',
    query: {
      saleChanceRefId: row.cosId
    }
  })
}
// 转签约
const handleSubContract = (row: PotentialItem) => {
  if (row.dataIntegrity !== 100) {
    Modal.confirm({
      title: t('custom.turnToContractModalTitle'),
      content: t('tips.EnS7LSHQ'),
      okText: t('btn.sure'),
      cancelText: t('btn.cancel'),
      onOk: () => {
        router.push({
          path: '/ofbu/potential/perfect',
          query: {
            cosId: row.cosId
          }
        })
      }
    })
  } else {
    router.push({
      path: '/ofbu/turnToContract',
      query: {
        cosId: row.cosId
      }
    })
  }
}
// 发送注册链接
const handleSendLink = (row: PotentialItem) => {
  sendLinkModelRef.value.toggle(row)
}
// 客户激活
const handleActivateAccount = (row: PotentialItem) => {
  router.push({ path: '/ofbu/accountActivation/add', query: { cosId: row.cosId } })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 36
const columns = computed(() => [
  {
    title: t('custom.customerName'),
    dataIndex: 'customerName',
    width: 200,
    fixed: 'left'
  },
  { title: t('custom.cosId'), dataIndex: 'cosId', width: 200 },
  { title: t('custom.customerNumber'), dataIndex: 'customerNumber' },
  { title: t('custom.channel'), dataIndex: 'channel', width: 150 },
  { title: t('custom.potentialStatus'), dataIndex: 'status', dicData: dataConfig.potentialStatusEnum },
  { title: t('custom.customerRegion'), dataIndex: 'customerRegion' },
  { title: t('custom.followerName'), dataIndex: 'sellerName' },
  { title: t('custom.remanentFollowDayType'), dataIndex: 'remanentFollowDays' },
  { title: t('custom.notFollowDayNum'), dataIndex: 'unfollowDays' },
  { title: t('custom.arkCode'), dataIndex: 'arkCode' },
  { title: t('common.contactName'), dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: t('common.mobile'), dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: t('common.skype'), dataIndex: ['contact', 'skype'], cosType: 'mask' },
  { title: t('common.email'), dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: t('common.sex'), dataIndex: ['contact', 'sex'], dicData: dataConfig.genderEnum },
  { title: t('common.jobRole'), dataIndex: ['contact', 'jobRole'], dicData: dataConfig.linkRoleTypeEnum },
  { title: t('common.jobDuty'), dataIndex: ['contact', 'jobDuty'] },
  { title: t('common.createTime'), dataIndex: 'createTime' },
  { title: t('custom.turnedPotentialTime'), dataIndex: 'turnedPotential', width: 190 },
  { title: t('custom.最后一次领取时间'), dataIndex: 'lastReceiveTime' },
  { title: t('custom.officialWeb'), dataIndex: 'officialWeb' },
  { title: t('custom.companyDetailedAddress'), dataIndex: 'customerAddress' },
  { title: t('custom.marketActivity'), dataIndex: 'activityQrcodeId', dicData: marketOptions.value },
  { title: t('custom.clientType'), dataIndex: 'clientType', dicData: paramCodeData.ofbu_client_type },
  {
    title: t('custom.annualSales'),
    dataIndex: ['business', 'annualSalesUnit'],
    dicData: paramCodeData.ofbu_currency,
    width: 140
  },
  {
    title: t('custom.salesChannel'),
    dataIndex: ['business', 'salesChannel'],
    dicData: paramCodeData.ofbu_sales_channel
  },
  {
    title: t('custom.customerBusinessType'),
    dataIndex: ['business', 'businessType'],
    dicData: paramCodeData.ofbu_business_type
  },
  {
    title: t('custom.服务标准'),
    dataIndex: ['business', 'serviceStandard'],
    dicData: paramCodeData.ofbu_services_standard
  },
  {
    title: t('custom.产品分类'),
    dataIndex: ['business', 'salesCategory'],
    dicData: paramCodeData.ofbu_sales_category
  },
  {
    title: t('custom.产品尺寸'),
    dataIndex: ['business', 'cargoType'],
    dicData: paramCodeData.ofbu_product_type
  },
  {
    title: t('custom.订单类型分布'),
    dataIndex: ['business', 'orderTypeDistribution']
  },
  {
    title: t('custom.单品多品订单比例'),
    dataIndex: ['business', 'orderDistribution']
  },
  {
    title: t('custom.SKU种类'),
    dataIndex: ['business', 'skuType']
  },
  {
    title: t('custom.尾程服务需求'),
    dataIndex: ['business', 'serviceType'],
    dicData: paramCodeData.ofbu_service_type
  },
  {
    title: t('custom.区域仓'),
    dataIndex: ['business', 'regionalWarehouse'],
    dicData: paramCodeData.ofbu_demand_info
  },
  {
    title: t('custom.平均在库体积'),
    dataIndex: ['business', 'averageInventoryVolume']
  },
  { title: t('custom.预计第一次来货时间'), dataIndex: ['business', 'firstInboundTime'] },
  {
    title: t('custom.入库包装方式'),
    dataIndex: ['business', 'inboundPackageType'],
    dicData: paramCodeData.ofbu_inbound_package_type
  },
  {
    title: t('custom.SKU单位'),
    dataIndex: ['business', 'skuUnit'],
    dicData: paramCodeData.ofbu_sku_unit
  },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 255,
      en: 340
    },
    fixed: 'right'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: queryForm.dataPermissionType,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.dataPermissionType) = $event)),
            onChange: search
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: undefined,
                tab: _unref(t)('common.all')
              }, null, 8, ["tab"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 1,
                tab: _unref(t)('custom.myCustomers'),
                "force-render": ""
              }, null, 8, ["tab"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 2,
                tab: _unref(t)('custom.subordinateCustomers')
              }, null, 8, ["tab"]))
            ]),
            _: 1
          }, 8, ["activeKey"]),
          _createVNode(_component_cos_table, {
            rowKey: "cosId",
            "row-selection": { onChange: onSelectChange },
            columns: columns.value,
            tableId: "DcCosOfbuPotential",
            onFetch: fetch,
            onMask: showMask,
            search: queryForm,
            "onUpdate:search": _cache[19] || (_cache[19] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.customerStatus')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosSelect, {
                        value: queryForm.status,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.status) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseSelect'),
                        mode: "multiple",
                        options: _unref(dataConfig).potentialStatusEnum
                      }, null, 8, ["value", "placeholder", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.customerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customerName) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.remanentFollowDayType')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosSelect, {
                        value: queryForm.remanentFollowDayType,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.remanentFollowDayType) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseSelect'),
                        options: _unref(dataConfig).remanentFollowDayTypeEnum
                      }, null, 8, ["value", "placeholder", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.turnedPotentialTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.turnedPotentialStart,
                        "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.turnedPotentialStart) = $event)),
                        endTime: queryForm.turnedPotentialEnd,
                        "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.turnedPotentialEnd) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.arkCode')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.arkCode,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.arkCode) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.contactMethod')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.contact.type,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.contact.type) = $event)),
                            style: {"width":"33%"},
                            placeholder: _unref(t)('common.pleaseSelect')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('common.mobile')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('common.email')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 3 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('common.skype')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value", "placeholder"]),
                          _createVNode(_component_a_input, {
                            value: queryForm.contact.keyword,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.contact.keyword) = $event)),
                            style: {"width":"67%"},
                            placeholder: _unref(t)('common.pleaseInput')
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.followerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        value: queryForm.sellerList,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.sellerList) = $event)),
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: "",
                        mode: "multiple"
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.receiveTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.receiveStart,
                        "onUpdate:startTime": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.receiveStart) = $event)),
                        endTime: queryForm.receiveEnd,
                        "onUpdate:endTime": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.receiveEnd) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.cosId')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cosId,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.cosId) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.notFollowDayNum')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosSelect, {
                        value: queryForm.unfollowDayType,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.unfollowDayType) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseSelect'),
                        options: _unref(dataConfig).customerUnfollowDayTypeEnum
                      }, null, 8, ["value", "placeholder", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.channel')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(ParamCodeCascader, {
                            type: "search",
                            ids: queryForm.channelList,
                            "onUpdate:ids": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.channelList) = $event)),
                            appId: "cos_ofbu",
                            paramCode: "ofbu_source_channel",
                            style: {"width":"33%"}
                          }, null, 8, ["ids"]),
                          _createVNode(_component_a_input, {
                            value: queryForm.channelExplain,
                            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((queryForm.channelExplain) = $event)),
                            maxlength: 100,
                            style: {"width":"67%"},
                            placeholder: _unref(t)('common.pleaseInput'),
                            allowClear: ""
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "activityQrcodeId",
                    label: _unref(t)('custom.marketActivity')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosSelect, {
                        value: queryForm.activityQrcodeId,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((queryForm.activityQrcodeId) = $event)),
                        options: marketOptions.value,
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: "",
                        optionFilterProp: "label",
                        showSearch: ""
                      }, null, 8, ["value", "options", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'customerName')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (record.timeoutFlag === true)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)('enum.overDue')), 1))
                      : _createCommentVNode("", true),
                    (record.haveFollowFlag === false)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "New"))
                      : _createCommentVNode("", true),
                    (record.blackListFlag)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('enum.blackList')), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: `/ofbu/potential/view?cosId=${record.cosId}`,
                      class: "ant-table-cell-ellipsis",
                      title: text
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(text || '--'), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "title"])
                  ]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'channel')
                ? (_openBlock(), _createBlock(ChannelText, {
                    key: 1,
                    appId: "cos_ofbu",
                    paramCode: "ofbu_source_channel",
                    value: text,
                    desc: record.channelExplain
                  }, null, 8, ["value", "desc"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerRegion')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 2,
                    appId: "cos_ofbu",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'arkCode')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(Array.isArray(text) && text.length > 0 ? text.join('、') : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === '$business.annualSalesUnit')
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(record.business?.annualSales
                  ? `${record.business.annualSales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${text}`
                  : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'dataIntegrity')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createTextVNode(_toDisplayString(`${text || 0}%`), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'warehousesAmount')
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(record.business?.demandInfo?.warehouses
                  ? amount(record.business.demandInfo?.warehouses)
                      ?.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 7 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleSendLink(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.sendRegist')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_potential_send_link_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleActivateAccount(record)),
                        disabled: !record.customerNumber || record.oaAuditStatus === '20' || record.oaAuditStatus === '30'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.客户激活')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])), [
                        [_directive_permission, 'ofbu_potential_account_activate_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleFollowUp(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.writeFollow')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, !record.blackListFlag],
                        [_directive_permission, 'ofbu_potential_follow_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (hanleAddVisitor(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.addVisitor')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_potential_visitor_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                        type: "link",
                        workCode: record.seller,
                        onClick: ($event: any) => (handleAddBuss(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.addBussiess')), 1)
                        ]),
                        _: 2
                      }, 1032, ["workCode", "onClick"])), [
                        [_directive_permission, 'ofbu_potential_buss_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleAddCode(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.addArkCode')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, !record.blackListFlag],
                        [_directive_permission, 'ofbu_potential_code_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleRelationCode(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.relatedCode')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, !record.blackListFlag],
                        [_directive_permission, 'ofbu_potential_code_relative_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_potential_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleDelete(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_potential_del_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (handleTransfer()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.transferCustomer')), 1)
                ]),
                _: 1
              })), [
                [_directive_permission, 'ofbu_potential_transfer_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (handleArchive()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.archive')), 1)
                ]),
                _: 1
              })), [
                [_directive_permission, 'ofbu_potential_archive_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(CosMergeButton), {
                data: selectedRows.value,
                appId: "cos_ofbu",
                fbuType: 2,
                onSuccess: success
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.merge')), 1)
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_permission, 'ofbu_potential_customer_aggregation_merge_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_ofbu",
                taskType: "403",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.export')), 1)
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'ofbu_potential_export_btn']
              ])
            ]),
            _: 1
          }, 8, ["row-selection", "columns", "search"]),
          _createVNode(sendLinkModel, {
            ref_key: "sendLinkModelRef",
            ref: sendLinkModelRef
          }, null, 512),
          _createVNode(addCodeModel, {
            ref_key: "addCodeModelRef",
            ref: addCodeModelRef,
            onSuccess: success
          }, null, 512),
          _createVNode(relationCode, {
            ref_key: "relationCodeRef",
            ref: relationCodeRef,
            onSuccess: success
          }, null, 512),
          _createVNode(transferModel, {
            ref_key: "transferModelRef",
            ref: transferModelRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})